import { Box } from "@/components/ui/box";
import { HStack } from "@/components/ui/hstack";
import { Text } from "@/components/ui/text";



export default function ChatBubble({ type, message, ...containerProps}) {
    // type = 'sent' || 'received'

    return (<HStack
        className={type === "sent" ? "justify-end" : "justify-start"}
        {...containerProps}
    >
        <Box
            className={`max-w-[80%] py-2 px-3 rounded-md border border-trueGray-300 ${
                type === "sent" ? "bg-white" : "bg-primary-900"
            }`}
        >
            <Text
                className={type === "sent" ? "text-black" : "text-white"}
            >
                {message}
            </Text>
        </Box>
    </HStack>)

}
